import { PropsWithChildren } from 'react';
import { View } from 'react-native';
import { CreateResponsiveStyle, DEVICE_SIZES, minSize } from 'rn-responsive-styles';

import { colors, spacing } from '../../theme';

import { DefaultLayout } from '../DefaultLayout';
import { HeaderBackButton } from '../Header';
import { Text } from '../Text';

export const CardLayout = ({ title, subtitle, children }: CardLayoutProps) => {
	const styles = useStyles();

	return (
		<DefaultLayout style={styles.container}>
			<View style={styles.card}>
				<HeaderBackButton />
				<Text category="h3" style={styles.textMargin}>
					{title}
				</Text>
				<Text category="p1">{subtitle}</Text>
				{children}
			</View>
		</DefaultLayout>
	);
};

const useStyles = CreateResponsiveStyle(
	{
		container: {
			paddingVertical: spacing(3),
			justifyContent: 'center',
			flexDirection: 'row',
		},
		card: {
			backgroundColor: colors.white,
			borderRadius: 32,
			flex: 1,
			padding: spacing(3),
		},
		textMargin: {
			marginVertical: spacing(2),
		},
	},
	{
		[minSize(DEVICE_SIZES.MD)]: {
			container: {
				paddingVertical: spacing(4),
			},
			card: {
				padding: spacing(5),
				maxWidth: 843,
			},
		},
		[minSize(DEVICE_SIZES.LG)]: {
			container: {
				paddingVertical: spacing(7),
			},
			card: {
				padding: spacing(10),
			},
		},
	},
);

export type CardLayoutProps = PropsWithChildren<{
	title: string;
	subtitle?: string;
}>;
